/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Device_Not_RegisteredInputs */

const th_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อุปกรณ์นี้ไม่อยู่ในรายการด้านบน จึงจะไม่ได้รับการแจ้งเตือน แม้ว่าหน้านี้จะแสดงว่าเปิดอยู่ก็ตาม ให้ปิดแล้วเปิดการแจ้งเตือนใหม่เพื่อลงทะเบียน`)
};

const en_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device is not on the list above, so nothing will reach it — even though notifications look switched on here. Turn them off and on again to register it.`)
};

const ja_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この端末は上の一覧にないため、通知は届きません。ここではオンに見えていても同じです。通知をオフにしてからオンに戻すと登録されます。`)
};

const zh_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此设备不在上面的列表中，所以不会收到任何内容——即使这里的通知看起来是开着的。关闭再打开即可注册它。`)
};

const es_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este dispositivo no está en la lista de arriba, así que no le llegará nada, aunque aquí las notificaciones parezcan activadas. Desactívalas y vuelve a activarlas para registrarlo.`)
};

const pt_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este dispositivo não está na lista acima, então nada chegará nele — mesmo que as notificações pareçam ligadas aqui. Desligue e ligue de novo para registrá-lo.`)
};

const id_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perangkat ini tidak ada di daftar di atas, jadi tidak ada yang sampai — sekalipun notifikasi di sini tampak aktif. Matikan lalu nyalakan lagi untuk mendaftarkannya.`)
};

const fr_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet appareil n’est pas dans la liste ci-dessus, donc rien ne lui parviendra — même si les notifications semblent activées ici. Désactivez-les puis réactivez-les pour l’enregistrer.`)
};

const tl_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala ang device na ito sa listahan sa itaas, kaya walang darating — kahit mukhang naka-on ang mga notipikasyon dito. Patayin at buksang muli para mairehistro ito.`)
};

const vi_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiết bị này không có trong danh sách trên, nên sẽ không nhận được gì — dù thông báo ở đây trông như đang bật. Tắt rồi bật lại để đăng ký nó.`)
};

const ko_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 기기는 위 목록에 없어 아무것도 도착하지 않습니다. 여기 알림이 켜진 것처럼 보여도 마찬가지입니다. 껐다가 다시 켜서 등록하세요.`)
};

const de_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Gerät steht nicht in der Liste oben, es kommt also nichts an — auch wenn die Benachrichtigungen hier aktiviert aussehen. Schalte sie aus und wieder ein, um es zu registrieren.`)
};

const ru_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этого устройства нет в списке выше, поэтому ничего не придёт — даже если уведомления здесь выглядят включёнными. Выключите и включите снова, чтобы зарегистрировать его.`)
};

const tr_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu cihaz yukarıdaki listede yok, bu yüzden hiçbir şey ulaşmaz — bildirimler açık görünse bile. Kaydetmek için kapatıp yeniden açın.`)
};

const it_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo dispositivo non è nell'elenco qui sopra, quindi non arriverà nulla, anche se le notifiche sembrano attive. Disattivale e riattivale per registrarlo.`)
};

const pl_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tego urządzenia nie ma na liście powyżej, więc nic nie dotrze — nawet jeśli powiadomienia wyglądają na włączone. Wyłącz je i włącz ponownie, aby je zarejestrować.`)
};

const uk_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цього пристрою немає в списку вище, тож нічого не надійде — навіть якщо сповіщення виглядають увімкненими. Вимкніть і ввімкніть їх знову, щоб зареєструвати його.`)
};

const hi_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह उपकरण ऊपर की सूची में नहीं है, इसलिए कुछ नहीं पहुँचेगा — भले ही यहाँ सूचनाएँ चालू दिखें। इसे दर्ज करने के लिए बंद करके फिर चालू करें।`)
};

const ar_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا الجهاز ليس في القائمة أعلاه، فلن يصل شيء — حتى لو بدت الإشعارات مفعّلة هنا. أوقفها ثم شغّلها لتسجيله.`)
};

const ms_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peranti ini tiada dalam senarai di atas, jadi tiada apa akan sampai — walaupun pemberitahuan di sini kelihatan hidup. Matikan dan hidupkan semula untuk mendaftarkannya.`)
};

const bn_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই যন্ত্রটি উপরের তালিকায় নেই, তাই কিছুই পৌঁছাবে না — এখানে বিজ্ঞপ্তি চালু দেখালেও নয়। নিবন্ধন করতে বন্ধ করে আবার চালু করুন।`)
};

const zh_tw2_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這台裝置不在上面的清單中，因此不會收到任何內容——即使這裡的通知看起來是開著的。請關閉再開啟以完成註冊。`)
};

const zh_hk2_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這台裝置不在上面的清單中，因此不會收到任何內容——即使這裡的通知看起來是開著的。請關閉再開啟以完成註冊。`)
};

const ur_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ آلہ اوپر کی فہرست میں نہیں، اس لیے کچھ نہیں پہنچے گا — چاہے یہاں اطلاعات چالو دکھائی دیں۔ اسے درج کرنے کے لیے بند کر کے دوبارہ چالو کریں۔`)
};

const fa_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این دستگاه در فهرست بالا نیست، پس چیزی نمی‌رسد — حتی اگر اعلان‌ها اینجا روشن به نظر برسند. برای ثبت آن، خاموش و دوباره روشن کنید.`)
};

const sw_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kifaa hiki hakipo kwenye orodha ya juu, kwa hivyo hakitapokea chochote — hata kama arifa zinaonekana zimewashwa hapa. Zima kisha washa tena ili kukisajili.`)
};

const nl_device_not_registered = /** @type {(inputs: Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit apparaat staat niet in de lijst hierboven, dus er komt niets aan — ook al lijken de meldingen hier aan te staan. Zet ze uit en weer aan om het te registreren.`)
};

/**
* | output |
* | --- |
* | "This device is not on the list above, so nothing will reach it — even though notifications look switched on here. Turn them off and on again to register it." |
*
* @param {Device_Not_RegisteredInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const device_not_registered = /** @type {((inputs?: Device_Not_RegisteredInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_Not_RegisteredInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_device_not_registered(inputs)
	if (locale === "ja") return ja_device_not_registered(inputs)
	if (locale === "zh") return zh_device_not_registered(inputs)
	if (locale === "es") return es_device_not_registered(inputs)
	if (locale === "pt") return pt_device_not_registered(inputs)
	if (locale === "id") return id_device_not_registered(inputs)
	if (locale === "fr") return fr_device_not_registered(inputs)
	if (locale === "tl") return tl_device_not_registered(inputs)
	if (locale === "vi") return vi_device_not_registered(inputs)
	if (locale === "ko") return ko_device_not_registered(inputs)
	if (locale === "de") return de_device_not_registered(inputs)
	if (locale === "ru") return ru_device_not_registered(inputs)
	if (locale === "tr") return tr_device_not_registered(inputs)
	if (locale === "it") return it_device_not_registered(inputs)
	if (locale === "pl") return pl_device_not_registered(inputs)
	if (locale === "uk") return uk_device_not_registered(inputs)
	if (locale === "hi") return hi_device_not_registered(inputs)
	if (locale === "ar") return ar_device_not_registered(inputs)
	if (locale === "ms") return ms_device_not_registered(inputs)
	if (locale === "bn") return bn_device_not_registered(inputs)
	if (locale === "zh-TW") return zh_tw2_device_not_registered(inputs)
	if (locale === "zh-HK") return zh_hk2_device_not_registered(inputs)
	if (locale === "ur") return ur_device_not_registered(inputs)
	if (locale === "fa") return fa_device_not_registered(inputs)
	if (locale === "sw") return sw_device_not_registered(inputs)
	if (locale === "nl") return nl_device_not_registered(inputs)
	return en_device_not_registered(inputs)
});